export default __webpack_public_path__ + "static/media/notification-1733829941154.07ffba0a.png";